import { render, staticRenderFns } from "./AgentRateCard.vue?vue&type=template&id=6bc5c812&scoped=true&"
import script from "./AgentRateCard.vue?vue&type=script&lang=js&"
export * from "./AgentRateCard.vue?vue&type=script&lang=js&"
import style0 from "./AgentRateCard.vue?vue&type=style&index=0&id=6bc5c812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc5c812",
  null
  
)

export default component.exports